import { render, staticRenderFns } from "./CreateEditProduct.vue?vue&type=template&id=a7842f42"
import script from "./CreateEditProduct.vue?vue&type=script&lang=js"
export * from "./CreateEditProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports